export default __webpack_public_path__ + "static/media/pie_chart.608e1a42.png";